import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { fontStack, printFontFace } from '../utils.js';
import { SBonus } from '../SBonus/index.js';
import { createGlobalStyle } from '../../components/global-styles.js';

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var weights = {
  xLight: 200,
  light: 300,
  book: 400,
  medium: 500,
  bold: 700,
  black: 800
};
var GothamSSm = _objectSpread(_objectSpread({}, SBonus), {}, {
  fontFamily: fontStack(['GothamSSm', 'arial', 'sans-serif']),
  defaultWeight: weights.book,
  sizes: {
    xxxl: {
      fontSize: '30rem',
      lineHeight: '3.5rem'
    },
    // No values in sokos-hotels theme yet, 30rem placeholder
    xxl: {
      fontSize: '30rem',
      lineHeight: '2.25rem'
    },
    // No values in sokos-hotels theme yet, 30rem placeholder
    xl: {
      fontSize: '1.875rem',
      lineHeight: '2.375rem'
    },
    l: {
      fontSize: '1.5rem',
      lineHeight: '1.875rem'
    },
    m: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem'
    },
    s: {
      fontSize: '1.0rem',
      lineHeight: '1.25rem'
    },
    xs: {
      fontSize: '0.875rem',
      lineHeight: '1rem'
    },
    xxs: {
      fontSize: '0.75rem',
      lineHeight: '0.875rem'
    },
    xxxs: {
      fontSize: '30rem',
      lineHeight: '1rem'
    } // No values in sokos-hotels theme yet, 30rem placeholder

  },
  weights: weights,
  CSS: createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), printFontFace('GothamSSm', weights.xLight, 'normal', 'GothamSSm-XLight_Web'), printFontFace('GothamSSm', weights.light, 'normal', 'GothamSSm-Light_Web'), printFontFace('GothamSSm', weights.book, 'normal', 'GothamSSm-Book_Web'), printFontFace('GothamSSm', weights.medium, 'normal', 'GothamSSm-Medium_Web'), printFontFace('GothamSSm', weights.bold, 'normal', 'GothamSSm-Bold_Web'), printFontFace('GothamSSm', weights.black, 'normal', 'GothamSSm-Black_Web'), printFontFace('GothamSSm', weights.xLight, 'italic', 'GothamSSm-XLightItalic_Web'), printFontFace('GothamSSm', weights.light, 'italic', 'GothamSSm-LightItalic_Web'), printFontFace('GothamSSm', weights.book, 'italic', 'GothamSSm-BookItalic_Web'), printFontFace('GothamSSm', weights.medium, 'italic', 'GothamSSm-MediumItalic_Web'), printFontFace('GothamSSm', weights.bold, 'italic', 'GothamSSm-BoldItalic_Web'), printFontFace('GothamSSm', weights.black, 'italic', 'GothamSSm-BlackItalic_Web'))
});

export { GothamSSm };
//# sourceMappingURL=index.js.map
